import { render, staticRenderFns } from "./BaseOpenCard.vue?vue&type=template&id=0aab5a3e&scoped=true&"
import script from "./BaseOpenCard.vue?vue&type=script&lang=js&"
export * from "./BaseOpenCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseOpenCard.vue?vue&type=style&index=0&id=0aab5a3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab5a3e",
  null
  
)

export default component.exports